import { useMemo, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface CustomDecimalsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (decimals: number) => void;
  initialDecimals?: number;
}

export function CustomDecimalsDialog({
  open,
  onOpenChange,
  onConfirm,
  initialDecimals,
}: CustomDecimalsDialogProps) {
  const [value, setValue] = useState<string>(String(initialDecimals ?? ''));

  const parsed = useMemo(() => {
    const n = Number(value);
    if (!Number.isFinite(n)) return null;
    if (!Number.isInteger(n)) return null;
    if (n < 0) return null;
    if (n > 50) return null; // Choose a reasonable max value for decimals
    return n;
  }, [value]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Custom decimals</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <Input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="e.g. 8"
            inputMode="numeric"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (parsed === null) return;
              onConfirm(parsed);
              onOpenChange(false);
            }}
            disabled={parsed === null}
          >
            Apply
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
